import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

const EmailStatsSchema = new mongoose.Schema({
  user: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.USER },
  totalEmailReceived: { type: Number },
  totalEmailSent: { type: Number },
  totalEmailRead: { type: Number },
  avgEmailPerDay: { type: Number },
  avgResponseTime: { type: Number },
  timeSpendReadingEmail: { type: Number },
  dayWithTheMostEmails: { type: mongoose.Schema.Types.Mixed },
  emailPerCategory: { type: mongoose.Schema.Types.Mixed },
  totalUrgentEmails: { type: Number },
  totalInboxCount: { type: Number },
});

export type T_EmailStats = InferSchemaType<typeof EmailStatsSchema>;

// Extending the type to enforce the specific structure for dayWithTheMostEmails
export interface T_EmailStatsWithStructure extends Omit<T_EmailStats, 'dayWithTheMostEmails' | 'emailPerCategory'> {
  dayWithTheMostEmails?: {
    day: string;
    total: number;
  };
  emailPerCategory?: Record<string, number>;
}

export type T_EmailStatsDocument = T_EmailStatsWithStructure &
  Document & {
    _id: string;
  };

export { EmailStatsSchema };
